import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconProgramSolid24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="program solid">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.5 4C0.223858 4 0 4.22386 0 4.5V7.88715C2 7.88715 4 9.5 4 12C4 14.5 2 16 0 16V19.5C0 19.7761 0.223857 20 0.5 20H23.5C23.7761 20 24 19.7761 24 19.5V16.1131C22 16 20 13.8638 20 12C20 10.1362 22 8 24 8V4.5C24 4.22386 23.7761 4 23.5 4H0.5ZM7 7.88715V16.1131C7 16.6029 7.40895 17 7.91342 17C8.04187 17 8.16887 16.9737 8.28614 16.9228L16.6309 12.9008C17.3854 12.5372 17.3853 11.4628 16.6309 11.0992L8.28614 7.07742C7.82558 6.87754 7.28535 7.07804 7.0795 7.52525C7.02709 7.63911 7 7.76243 7 7.88715ZM14.5 12L9 14.5V9.5L14.5 12Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
